import { TemplateRef } from "@angular/core";

export class QuestionCompany {
    questionId: string;
    key: string;
    question: string;
    enabled: boolean;
    checked?: boolean;
    parent: number;
    templateRef?: TemplateRef<any>;
}